<section class="product-tickets {{scheme}}">
  @if (showFilter) {
    <section class="filter">
      <h1>Choose Location:</h1>
      <button (click)="setFilter()" [ngClass]="{disabled: !filter}">All</button>
      @for (location of tickets.locations; track location) {
        <button (click)="setFilter(location.id)"
          [ngClass]="{disabled: location.id == filter}">
          {{ location.title }}
        </button>
      }
    </section>
  }
  <section class="months">
    @for (month of tickets.dates; track month) {
      <section class="month">
        <header (click)="setMonth(month.dateString)" (keydown)="setMonth(month.dateString)" class="dropdown button secondary tiny">
          <h1>
            {{ month.dateString + '-01' | date : 'MMM yyyy' }}<br />
            @for (day of month.days | keyvalue; track day; let last = $last) {
              <small [ngClass]="{'sold-out': !day.value}">
                {{ day.key | date : 'd MMM' }}{{ (!last && ', ') || '' }}
              </small>
            }
          </h1>
        </header>
        @if (displayMonth == month.dateString) {
          <section class="days">
            @for (ticket of month.tickets; track ticket) {
              <section class="day"
                [hidden]="filter && ticket.CompanyLocation.id !== filter"
                [ngClass]="{disabled: ticket.purchased || !ticket.stock_quantity}">
                <h1>
                  {{ ticket.day | date : 'd MMM' }}
                  {{ (ticket.start_time && ticket.start_time.name) || '' }}<br />
                  <small>{{ ticket.displayDate }}</small>
                </h1>
                <p>{{ ticket.displayLocation }}</p>
                <h2 class="partner-price">
                  {{ formatPrice(ticket.prices[0].price) }}<br />
                  <br />
                  <small>{{ ticket.prices[0].label }}</small>
                </h2>
                @if (
                  !ticket.staged_release && (!ticket.purchased || ticket.anarchy)
                  ) {
                  <button [disabled]="!ticket.stock_quantity" (click)="pickOptions(ticket)">
                    {{
                    (!!ticket.stock_quantity &&
                    'Buy Now') ||
                    'Sold Out'
                    }}
                  </button>
                }
                @if (
                  ticket.staged_release && (!ticket.purchased || ticket.anarchy)
                  ) {
                  <button class="ticket-button" (click)="pickOptions(ticket)" [disabled]="!ticket.stock_quantity">
                    {{ checkStagedRelease(ticket) }}
                  </button>
                }
                @if (ticket.purchased && !ticket.processing && !ticket.anarchy) {
                  <button disabled>
                    {{ (isBallot && 'Applied') || 'Purchased' }} on :
                    {{ ticket.purchased * 1000 | date }}
                  </button>
                }
                @if (ticket.processing && !ticket.anarchy) {
                  <button disabled>
                    Processing...
                  </button>
                }
              </section>
            }
          </section>
        }
      </section>
    }
  </section>
  @if (tickets && !tickets.available) {
    <button disabled>Sold out!</button>
  }
</section>